import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import checkIcon from "@tabler/icons/outline/check.svg";
import React from "react";

import { cn } from "@/utils/cn";

import SvgIcon from "../icon/svg-icon";

interface CheckboxProps extends React.ComponentProps<
  typeof CheckboxPrimitive.Root
> {}

/** A pretty checkbox input. */
const Checkbox = ({ className, ...props }: CheckboxProps) => (
  <CheckboxPrimitive.Root
    data-slot="checkbox"
    className={cn(
      "flex size-4 flex-none items-center justify-center rounded-sm border border-gray-600 has-focus-visible:ring-2 has-focus-visible:ring-primary-500 has-focus-visible:ring-offset-2 data-checked:border-transparent data-checked:bg-primary-500 dark:bg-gray-900 dark:has-focus-visible:ring-offset-gray-900 dark:data-checked:bg-primary-400",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      data-slot="checkbox-indicator"
      className="flex text-white"
    >
      <SvgIcon src={checkIcon} className="size-3.5" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);

export { Checkbox as default, Checkbox, type CheckboxProps };
